/**
 * Error raised when the user dismisses the OTP form (closes the modal
 * or unmounts the slot) before completing verification. Surfaced on
 * the original request's promise so callers (mutations, queries) can
 * branch on it instead of treating it as a generic failure.
 */
export class OtpCancelledError extends Error {
  constructor(message = 'OTP verification was cancelled by the user') {
    super(message);
    this.name = 'OtpCancelledError';
  }
}

/**
 * Error raised when the backend reports the user has exceeded the
 * allowed OTP attempts. The form closes and the original request
 * fails with this error — callers should show a "try again later"
 * message rather than re-prompting.
 */
export class OtpTooManyAttemptsError extends Error {
  constructor(message = 'Too many OTP attempts. Please try again later.') {
    super(message);
    this.name = 'OtpTooManyAttemptsError';
  }
}

/**
 * Error raised when the backend fails to send the OTP code (transport
 * failure, mis-configured number, etc.). Distinct from invalid-OTP,
 * which loops the form; this short-circuits the flow.
 */
export class OtpFailedToSendError extends Error {
  constructor(message = 'Failed to send verification code. Please try again.') {
    super(message);
    this.name = 'OtpFailedToSendError';
  }
}
